import { render, staticRenderFns } from "./deletelogs.vue?vue&type=template&id=4dd15002&"
import script from "./deletelogs.vue?vue&type=script&lang=ts&"
export * from "./deletelogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deletelogs.vue"
export default component.exports